import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import "./stylesEventDetails.css";

import { SIDER_TABS } from "../../../utils/Constants";
import Layout from "../../CommonComponents/Layout/Layout";
import EventKpi from "./EventKpi/EventKpi";

import {
  CalendarOutlined,
  DribbbleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import LatestBetsList from "./LatestBetsList/LatestBetsList";
import Markets from "./Markets/Markets";
import { API_ROUTES } from "../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

function EventDetails() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const tabs = ["Event KPI", "Markets", "Latest Bets List"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handleBackToEvents = () => {
    navigate(-1);
  };

  const [eventHeaderDetails, setEventHeaderDetails] = useState([
    {
      competitors: [
        {
          name: "",
          qualifier: "",
          logo: "",
        },
        {
          name: "",
          qualifier: "",
          logo: "",
        },
      ],
    },
  ]);

  const getEventHeaderDetails = async () => {
    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_EVENT_DETAILS_HEADER,
        {
          event_id: eventId,
        }
      );
      let data = response?.data?.data;
      if (data?.status === "not_started") {
        data.status = "Future";
      }
      setEventHeaderDetails(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getEventHeaderDetails();
  }, []);

  return (
    <Layout name={SIDER_TABS?.SPORTSBOOK}>
      <div className="event-details-container">
        <div className="event-details-header">
          <LeftOutlined
            className="event-details-header-back-button"
            onClick={handleBackToEvents}
          />
          <h2>Back To Events</h2>
        </div>
        <div className="event-details-content">
          <div className="event-details-content-header">
            <div className="event-details-content-header-top">
              <div className="event-details-content-header-top-team-info">
                {eventHeaderDetails?.competitors?.[0]?.logo && (
                  <img
                    width={100}
                    src={eventHeaderDetails?.competitors?.[0]?.logo}
                    alt="team-logo"
                  />
                )}
                <p className="event-details-content-header-top-team-info-logo-name">
                  {eventHeaderDetails?.competitors?.[0]?.name}
                </p>
              </div>
              <div className="event-details-content-header-top-team-info-score">
                {eventHeaderDetails?.score?.home_score &&
                  eventHeaderDetails?.score?.away_score && (
                    <p className="event-details-content-header-top-team-info-score-score">
                      {eventHeaderDetails?.score?.home_score} :{" "}
                      {eventHeaderDetails?.score?.away_score}
                    </p>
                  )}
                <p
                  className={`event-details-content-header-top-team-info-score-status ${eventHeaderDetails?.status?.toLowerCase()}`}
                >
                  {eventHeaderDetails?.status}
                </p>
              </div>
              <div className="event-details-content-header-top-team-info">
                {eventHeaderDetails?.competitors?.[1]?.logo && (
                  <img
                    width={100}
                    src={eventHeaderDetails?.competitors?.[1]?.logo}
                    alt="team-logo"
                  />
                )}
                <p className="event-details-content-header-top-team-info-logo-name">
                  {eventHeaderDetails?.competitors?.[1]?.name}
                </p>
              </div>
            </div>
            <div className="event-details-content-header-bottom">
              <div className="event-details-content-header-bottom-info">
                <p className="event-details-content-header-bottom-info-title">
                  Date & Time
                </p>
                <p className="event-details-content-header-bottom-info-value">
                  <CalendarOutlined style={{ marginRight: "10px" }} />
                  {eventHeaderDetails?.display_date_time}
                </p>
              </div>
              <div className="event-details-content-header-bottom-info">
                <p className="event-details-content-header-bottom-info-title">
                  Sport Category
                </p>
                <p className="event-details-content-header-bottom-info-value">
                  <DribbbleOutlined style={{ marginRight: "10px" }} />
                  {eventHeaderDetails?.sport_category}
                </p>
              </div>
              <div className="event-details-content-header-bottom-info">
                <p className="event-details-content-header-bottom-info-title">
                  League
                </p>
                <p className="event-details-content-header-bottom-info-value">
                  {eventHeaderDetails?.league_name}
                </p>
              </div>
              <div className="event-details-content-header-bottom-info">
                <p className="event-details-content-header-bottom-info-title">
                  ID
                </p>
                <p className="event-details-content-header-bottom-info-value">
                  {eventHeaderDetails?.event_id}
                </p>
              </div>
            </div>
          </div>
          <div className="event-details-content-tabs-container">
            <div className="event-details-tabs">
              <button
                className={activeTab === "Event KPI" ? "active" : null}
                onClick={() => setActiveTab("Event KPI")}
              >
                Event KPI
              </button>
              <button
                className={activeTab === "Markets" ? "active" : null}
                onClick={() => setActiveTab("Markets")}
              >
                Markets
              </button>
              <button
                className={activeTab === "Latest Bets List" ? "active" : null}
                onClick={() => setActiveTab("Latest Bets List")}
              >
                Latest Bets List
              </button>
            </div>
            {activeTab === "Event KPI" && <EventKpi />}
            {activeTab === "Markets" && <Markets />}
            {activeTab === "Latest Bets List" && <LatestBetsList />}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default EventDetails;
